import Node from '../model/Node';
import MediaGrid from '../model/MediaGrid';

export const CHANGE_INFO_PAGES = 'CHANGE_INFO_PAGES';
export const SELECT_INFO_PAGE = 'SELECT_INFO_PAGE';
export const TOGGLE_EDIT = 'TOGGLE_EDIT';
export const SELECT_NODE = 'SELECT_NODE';
export const CHANGE_NODE_GLOBAL_DATA = 'CHANGE_NODE_GLOBAL_DATA';
export const CHANGE_NODE_INFO = 'CHANGE_NODE_INFO';
export const CHANGE_TREE_DATA = 'CHANGE_TREE_DATA';
export const COPY_DATA = 'COPY_DATA';
export const CHANGE_MEDIA_GRID = 'CHANGE_MEDIA_GRID';
export const CHANGE_TV_MODE = 'CHANGE_TV_MODE';
export const CHANGE_NODE_MAIN_DATA = 'CHANGE_NODE_MAIN_DATA';
export const MAIN_NODE_ID = 'MAIN_NODE_ID';
export const CHANGE_COUNT_LATEST_VERSION = 'CHANGE_COUNT_LATEST_VERSION';
export const INCREASE_COUNT_LATEST_VERSION = 'INCREASE_COUNT_LATEST_VERSION';
export const CHANGE_SELECTED_INFO_LANG = 'CHANGE_SELECTED_INFO_LANG';
export const SAVE_INFO_PAGE = 'SAVE_INFO_PAGE';
export const CHANGE_DIRTY_STATUS = 'CHANGE_DIRTY_STATUS';
export const RESET_INFO_PAGE = 'RESET_INFO_PAGE';

export const changeInfoPages = (infoPages = []) => ({
    type: CHANGE_INFO_PAGES,
    payload: infoPages
});

export const toggle = (isEditing: boolean) => ({
    type: TOGGLE_EDIT,
    payload: isEditing
});

export const selectNode = (node: object) => ({
    type: SELECT_NODE,
    payload: node
});

export const changeInfoPage = (infoPage: any) => ({
    type: SELECT_INFO_PAGE,
    payload: infoPage
});

export const changeTreeData = (tree: any[]) => ({
    type: CHANGE_TREE_DATA,
    payload: tree
});

export const changeCopyData = (data: any) => ({
    type: COPY_DATA,
    payload: data
});

export const changeMediaGrid = (data: MediaGrid) => ({
    type: CHANGE_MEDIA_GRID,
    payload: data
});

export const changeNodeMainData = (data: { id: number, data: any }) => ({
    type: CHANGE_NODE_MAIN_DATA,
    payload: data
});

export const changeNodeGlobalData = (data: Node, nodeSelectedId = -1, isDirty = true) => ({
    type: CHANGE_NODE_GLOBAL_DATA,
    payload: {
        data,
        nodeSelectedId,
        isDirty
    }
});

export const mainNodeIdData = (data: any) => ({
    type: MAIN_NODE_ID,
    payload: data
});

export const changeCountLatestVersion = (count: number) => ({
    type: CHANGE_COUNT_LATEST_VERSION,
    payload: count
});

export const increaseCountLatestVersion = () => ({
    type: INCREASE_COUNT_LATEST_VERSION
});

export const selectInfoPageLang = (data: any) => ({
    type: CHANGE_SELECTED_INFO_LANG,
    payload: data
});

export const saveInfoPage = (data: string) => ({
    type: SAVE_INFO_PAGE,
    payload: data
});

export const changeInfoPageDirtyStatus = (status: boolean) => ({
    type: CHANGE_DIRTY_STATUS,
    payload: status
});

export const resetInfoPage = () => ({
    type: RESET_INFO_PAGE
});
